// extracted by mini-css-extract-plugin
export default {"navigation":"BackButton_navigation"};